import App from 'containers/App'
import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import { hydrate } from 'react-dom'
import { loadableReady } from '@loadable/component'
import * as Sentry from '@sentry/react'
import { Replay } from '@sentry/replay'
import { determineLocale } from './i18n'
import useUrl from 'useUrl'
import ScrollToTop from 'components/ScrollToTop'
import { BrandProvider } from 'contexts/BrandContext'

if (process.env.NODE_ENV !== 'development') {
  console.log('Sentry DSN', process.env.RAZZLE_SENTRY_DSN)

  Sentry.init({
    dsn: process.env.RAZZLE_SENTRY_DSN,
    environment: process.env.RAZZLE_SENTRY_ENVIRONMENT,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
    integrations: process.env.NODE_ENV === 'production' ? [
      new Replay({
        sessionSampleRate: 1.0,
        errorSampleRate: 1.0,
        maskAllText: false,
        blockAllMedia: false,
      })
    ] : [],
  })
}

const locale = determineLocale(
  navigator.languages || [],
  window.location.pathname
)

loadableReady().then(() => {
  hydrate(
    <BrowserRouter basename={useUrl(locale)}>
      <ScrollToTop>
        <BrandProvider brandKey={window.env?.BRAND}>
          <App locale={locale} />
        </BrandProvider>
      </ScrollToTop>
    </BrowserRouter>,
    document.getElementById('root')
  )
})

if (module.hot) {
  module.hot.accept()
}
